<template>
    <v-snackbar v-model="showBanner" bottom color="grey darken-3" :timeout="0" elevation="2" dark>
        <div class="white--text d-flex flex-column flex-sm-row align-sm-center">
            <div>
                Wij gebruiken cookies om ervoor te zorgen dat u de beste ervaring op onze website krijgt.
                Lees ons
                <a href="https://itinera-talentcoaching.be/cookiebeleid/" target="_blank"
                    class="white--text text--underline">cookiebeleid</a>
                en
                <a href="https://itinera-talentcoaching.be/privacybeleid/" target="_blank"
                    class="white--text text--underline">privacybeleid</a>.
            </div>
            <v-spacer></v-spacer>
            <v-btn dark text @click="acceptCookies">Accepteren</v-btn>
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: 'CookieConsent',
    data() {
        return {
            showBanner: false,
        };
    },
    mounted() {
        const consent = localStorage.getItem('cookie_consent');
        if (!consent) {
            this.showBanner = true;
        }
    },
    methods: {
        acceptCookies() {
            localStorage.setItem('cookie_consent', 'accepted');
            this.showBanner = false;
        },
    },
};
</script>

<style scoped>
.text--underline {
    text-decoration: underline;
}
</style>
